<template>
    <div>
        <button class="btn btn-danger margined-left" v-on:click="openRejectModal">Reject</button>
        <div class="modal fade" id="rejectModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h2 class="user-search-title">Rejection reason</h2>
                    </div>
                    <div class="modal-body">
                        <textarea type="text" name="rejection_reason" v-model="reason"></textarea>
                    </div>
                    <div class="modal-footer">
                        <a v-bind:href="href + '?reason=' + encodeURI(this.reason)" type="button" class="btn btn-danger" >Reject</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ApprovalRequestRejectionButton",
        props: {
            href: {
                type: String,
                default: '#',
            }
        },
        data: function() {
            return {
                reason: '',
            }
        },
        methods: {
            openRejectModal: function (e) {
                e.stopPropagation;
                $('#rejectModal').modal('show');
            },
        }
    }
</script>

<style scoped>
    textarea {
        width: 100%;
    }
</style>
